import React from "react";
import PropTypes from "prop-types";

export default function Image({
    src,
    raised = false,
    rounded = false,
    className,
    ...rest
}) {
    return (
        <>
            <img
                {...rest}
                src={src}
                className={`${rounded ? "rounded-full" : "rounded-xl"} ${
                    raised ? "shadow-lg" : ""
                } max-h-full w-auto align-middle border-none ${className}`}
            />
        </>
    );
}


Image.propTypes = {
    src: PropTypes.string.isRequired,
    raised: PropTypes.bool,
    rounded: PropTypes.bool,
};
